import {EnvironmentCabinet} from 'compob2b-libs';

export class EnvironmentCabinetProd extends EnvironmentCabinet {
  production = true;
  // SW выпилен из контура витрины: свежесть статики держат content-hashed
  // бандлы + cache-заголовки nginx, не Service Worker. false → register(enabled:false)
  // + swUpdate.isEnabled=false (ракета-тост гаснет сам). Кабинет (environment.prod.ts)
  // остаётся true. См. docs/showcase-build-topology.md «Кэш и доставка статики».
  serviceWorkers = false;
  serverApi = 'https://showcase.compo-soft.ru/api/v1';
  serverPicturesPath = 'https://showcase.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://showcase.compo-soft.ru/documents';
  showcaseUrl = 'showcase.compo-soft.ru';
  aiTranslation = true;
}

export const environment = new EnvironmentCabinetProd();
